import { getConfig } from './config'
import { initAuth } from './auth/initAuth'
import { hydrateAuthTokenCache } from './api/auth-token-wrapper'
import { AuthProvider } from '@envision/ev-ui-component-library'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter } from 'react-router-dom'
import { persistor, store } from './store'
import { reactPlugin } from 'appInsights'
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import App from './App'

getConfig().then(async (cfg) => {
  initAuth(cfg)
  await hydrateAuthTokenCache()

  const container = document.getElementById('root')
  if (!container) {
    throw new Error('Root element with id "root" not found in DOM')
  }
  const root = createRoot(container)
  root.render(
    <AppInsightsContext.Provider value={reactPlugin}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AuthProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AuthProvider>
        </PersistGate>
      </Provider>
    </AppInsightsContext.Provider>
  )
})
